import { render, staticRenderFns } from "./BrandCard.vue?vue&type=template&id=6c4ca7dd&"
import script from "./BrandCard.vue?vue&type=script&lang=ts&"
export * from "./BrandCard.vue?vue&type=script&lang=ts&"
import style0 from "./BrandCard.vue?vue&type=style&index=0&id=6c4ca7dd&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports